module.exports = function getResource(label, vars = []) {
    const resources = {
        productPrice: 'Prix',
        fillSize: 'Taille de remplissage',
        rating: 'Cote',
        ingredientHighlights: 'Avantages des ingrédients',
        seeDetails: 'Voir les détails'
    };

    return resources[label];
};
